export default "__VITE_ASSET__CyEgQ_nv__"